module.exports = __webpack_public_path__ + "img/tijian_img4.532b4dd1.png";